import { render } from "./warehouse-list.vue?vue&type=template&id=3ebdb760"
import script from "./warehouse-list.vue?vue&type=script&lang=js"
export * from "./warehouse-list.vue?vue&type=script&lang=js"

import "./warehouse-list.vue?vue&type=style&index=0&id=3ebdb760&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__